module.exports = __webpack_public_path__ + "media/packs/images/flags/CZ-aa353b557f4bf44f478b4f34fa8d4542.svg";